import React from 'react';
import { Tooltip } from 'antd';

// SEC / FINRA terms with their explanatory hover text, shared by every disclosure that names them.
export const SecTooltip = () => (
  <Tooltip
    placement='bottom'
    title={
      <>
        The United States Securities and Exchange Commission (SEC) is an independent agency of the United States federal government. The SEC
        protects investors, promotes fairness in the securities markets, and shares information about companies and investment professionals
        to help investors make informed decisions and invest with confidence. Learn more at:{' '}
        <a style={{ color: '#2457C5' }} href='https://www.sec.gov/'>
          https://www.sec.gov/
        </a>
      </>
    }
  >
    <span className='underline cursor-pointer'>SEC</span>
  </Tooltip>
);

export const FinraTooltip = () => (
  <Tooltip
    placement='bottom'
    title={
      <>
        The Financial Industry Regulatory Authority (FINRA) is a private American corporation that acts as a self-regulatory organization that
        regulates member brokerage firms and exchange markets. FINRA is dedicated to protecting investors and safeguarding market integrity in
        a manner that facilitates vibrant capital markets. Learn more at:{' '}
        <a style={{ color: '#2457C5' }} href='https://www.finra.org/about'>
          {' '}
          https://www.finra.org/about
        </a>
      </>
    }
  >
    <span className='underline cursor-pointer'>FINRA</span>
  </Tooltip>
);

// Shared identity-verification disclosure paragraph shown on multiple Verification steps
// (StepOne/EntityDocs/StepTwo/StepThree's info panel, and UploadID's info panel).
const SecFinraDisclosure = () => (
  <p>
    We are required by federal law to verify the identity of any person creating an account to purchase shares. Realbricks complies with all{' '}
    <SecTooltip />{' '}
    and{' '}
    <FinraTooltip />{' '}
    customer identification rules.
  </p>
);

export default SecFinraDisclosure;
